"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

require("core-js/modules/es.symbol");

require("core-js/modules/es.symbol.description");

require("core-js/modules/es.symbol.iterator");

require("core-js/modules/es.array.iterator");

require("core-js/modules/es.array.slice");

require("core-js/modules/es.object.freeze");

require("core-js/modules/es.object.get-own-property-descriptor");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.string.iterator");

require("core-js/modules/es.weak-map");

require("core-js/modules/web.dom-collections.iterator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledTooltipWrapper = exports.StyledTooltipInner = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _base = _interopRequireDefault(require("../../style/themes/base"));

var _optionsHelper = _interopRequireDefault(require("../../utils/helpers/options-helper/options-helper"));

var _tooltip = require("./tooltip.utils");

var _styleHelper = require("../../utils/helpers/style-helper");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  bottom: auto;\n  right: auto;\n  max-width: 300px;\n  position: relative;\n  animation: ", " 0.2s linear;\n  z-index: ", ";\n  text-align: ", ";\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n      padding: 10px 15px;\n    "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n      background-color: ", ";\n    "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    background-color: ", ";\n    color: ", ";\n    display: inline-block;\n    padding: 12px 16px;\n    text-align: center;\n    max-width: 300px;\n    word-break: normal;\n    white-space: pre-wrap;\n    font-weight: 700;\n\n    ", "\n\n    ", "\n  "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  0% {\n    opacity: 0;\n  }\n\n  100% {\n    opacity: 1;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var fadeIn = (0, _styledComponents.keyframes)(_templateObject());

var StyledTooltipInner = _styledComponents.default.div(_templateObject2(), function (_ref) {
  var theme = _ref.theme,
      type = _ref.type;
  return (0, _styledComponents.css)(_templateObject3(), theme.colors.black, theme.colors.white, type === 'error' && (0, _styledComponents.css)(_templateObject4(), theme.colors.error), (0, _styleHelper.isClassic)(theme) && (0, _styledComponents.css)(_templateObject5()));
});

exports.StyledTooltipInner = StyledTooltipInner;

var StyledTooltipWrapper = _styledComponents.default.div(_templateObject6(), fadeIn, function (_ref2) {
  var theme = _ref2.theme;
  return theme.zIndex.popover;
}, function (_ref3) {
  var align = _ref3.align,
      position = _ref3.position;
  return getTextAlignment(position, align);
});

exports.StyledTooltipWrapper = StyledTooltipWrapper;
StyledTooltipInner.propTypes = {
  theme: _propTypes.default.object,
  type: _propTypes.default.string
};
StyledTooltipWrapper.propTypes = {
  align: _propTypes.default.oneOf(_optionsHelper.default.alignAroundEdges),
  position: _propTypes.default.oneOf(_optionsHelper.default.positions)
};
StyledTooltipWrapper.defaultProps = {
  theme: _base.default
};
StyledTooltipInner.defaultProps = {
  theme: _base.default
};

function getTextAlignment(position, align) {
  var textAlignment = 'center';

  if ((0, _tooltip.isHorizontal)(position)) {
    textAlignment = position;
  }

  if ((0, _tooltip.isHorizontal)(align)) {
    textAlignment = align;
  }

  return textAlignment;
}